export { default } from './FaqLayout';
